import React from 'react';
import PropTypes from 'prop-types';

import { ReactComponent as Search } from 'assets/images/svg/search.svg';

import StandardButton from 'components/shared/StandardButton';
import SearchAutocomplete from 'components/search/SearchAutoComplete';
import SearchDatePicker from 'components/search/SearchDatePicker';

import siteStyle from 'utils/siteStyle';

const SearchFormDesktop = ({
  date,
  setDate,
  location,
  setLocation,
  onSearch,
  searchFormError,
  initialAtCurrentLocation,
  isDirty,
}) => (
  <div className="flex gap-2">
    <SearchAutocomplete
      location={location}
      setLocation={setLocation}
      wrapperClassName="flex-1"
      searchFormError={searchFormError}
      initialAtCurrentLocation={initialAtCurrentLocation}
    />
    <SearchDatePicker
      value={date}
      onSelected={setDate}
      minDate={new Date()}
      wrapperClassName="w-full md:max-w-[214px] lg:max-w-74 2xl:max-w-[334px]"
    />
    <StandardButton
      text={(
        <div
          className={siteStyle({
            common: 'flex items-center justify-center gap-2',
            // bt: 'font-korolav uppercase',
            foh: 'font-rajdhani',
            default: 'font-primary',
          })}
        >
          <Search style={{ transform: 'rotateY(180deg)' }} className="w-4 h-4 text-white fill-current" />
          <p className="font-bold text-white -tracking-0.25 text-4 leading-4">{isDirty ? 'Update' : 'Search'}</p>
        </div>
        )}
      widthStyle="w-fit px-6"
      heightStyle="h-14"
      onClick={() => onSearch()}
    />
  </div>
);

SearchFormDesktop.defaultProps = {
  currentLocation: null,
  location: null,
  onSearch: null,
  date: new Date(),
  isDirty: false,
};

SearchFormDesktop.propTypes = {
  currentLocation: PropTypes.shape({
    city: PropTypes.string,
    hierarchizedUrl: PropTypes.string,
    lat: PropTypes.number,
    lon: PropTypes.number,
    slug: PropTypes.string,
    label: PropTypes.string,
  }),
  date: PropTypes.instanceOf(Date),
  location: PropTypes.shape({ label: PropTypes.string }),
  searchFormError: PropTypes.bool.isRequired,
  onSearch: PropTypes.func,
  setDate: PropTypes.func.isRequired,
  setLocation: PropTypes.func.isRequired,
  isDirty: PropTypes.bool,
  initialAtCurrentLocation: PropTypes.bool.isRequired,
};

export default SearchFormDesktop;
